var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-inner"},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.info))])]),_c('div',{staticClass:"content-inner",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('footerView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }